/**
 * Types of warnings possible
 */
export enum WARNING_STATUS {
    ERROR = "Error",
    WARNING = "Warning",
}

/**
 * Types of badges
 */
export enum BADGE_VARIANT {
    ERROR = WARNING_STATUS.ERROR,
    WARNING = WARNING_STATUS.WARNING,
}

/**
 * Defines specific icon variants, preset groups of settings
 */
export enum MARKER_VARIANT {
    SENSOR = "sensor",
    VALVE = "valve",
    GROUP = "group",
    DRAGINO_GATEWAY = "draginoGateway",
}

/**
 * Types of icon graphics
 */
export enum ICON_VARIANT {
    SENSOR = "sensor",
    VALVE = "valve",
    GROUP = "group",
    MANUAL_MODE = "manualMode",
    DRAGINO_GATEWAY = "draginoGateway",
}

/**
 * Colors that can be overridden by users via the notes field
 */
export enum NOTES_OVERRIDE_COLOR_VARIANT {
    BLUE = "blue",
    TEAL = "teal",
    YELLOW = "yellow",
    PURPLE = "purple",
    PINK = "pink",
    BROWN = "brown",
    INDIGO = "indigo",
}

export enum SHADOW_STYLE_VARIANT {
    SPARSE = "SPARSE",
    DENSE = "DENSE",
}
